import gql from 'graphql-tag';

export const createCondominiumProfileFeaturePermissions = gql`
  mutation createCondominiumProfileFeaturePermissions(
    $condominiumContextId: ID!
    $profileId: ID!
    $featurePermissions: [CondominiumProfileFeaturePermissionsInput]!
    $removeAllIndividualPermissions: Boolean!
  ) {
    createCondominiumProfileFeaturePermissions(
      condominiumContextId: $condominiumContextId
      profileId: $profileId
      featurePermissions: $featurePermissions
      removeAllIndividualPermissions: $removeAllIndividualPermissions
    )
  }
`;
